import { GridViewContainer } from './PropertiesListGridViewSkeletonLoader.styles';
export default function PropertiesListGridViewSkeletonLoader(props: { numberOfCards?: number }) {
  const numberOfCards = props?.numberOfCards || 12;
  return (
    <GridViewContainer className="grid-view">
      {Array.from({ length: numberOfCards }).map((_, index) => (
        <div key={index} className="skeleton-loader properties-card_skeleton"></div>
      ))}
    </GridViewContainer>
  );
}
